var AccessMethod;
(function (AccessMethod) {
    AccessMethod["TDMA"] = "tdma";
    AccessMethod["AdvancedTDMA"] = "atdma";
    AccessMethod["S_CDMA"] = "s_cdma";
    AccessMethod["OFDMA"] = "ofdma";
})(AccessMethod || (AccessMethod = {}));
export default AccessMethod;
